import React, { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import i18n from 'i18n';
import { sendRestorePasswordOTP } from 'actions/profile';
import useOnNavigationBack from 'hooks/useOnNavigationBack';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import Header from '../common/Header';
import PhoneForm from '../common/PhoneForm';
import { RestorePasswordContext } from './RestorePasswordContext';

const i18nScope = 'authorizationRestorePasswordPhonePage';
const SECTION_NAME = 'PHONE_NUMBER_INPUT';

const AuthorizationRestorePasswordPhonePage = () => {
  const dispatch = useDispatch();
  const { contextState, setContextState } = useContext(RestorePasswordContext);
  const { code, phone } = contextState;

  const onSubmit = useCallback(
    (values) => {
      innerAnalyticsVolia.postEvent({
        eventGroup: 'credentials recovery screen',
        eventName: 'click send password',
        eventValue: 'login type="phone"',
      });
      setContextState((state) => ({ ...state, ...values }));
      dispatch(sendRestorePasswordOTP({ ...values, errorModal: { returnFocusTo: `@${SECTION_NAME}` } }));
    },
    [dispatch, setContextState],
  );

  useOnNavigationBack(() => setContextState((state) => ({ ...state, phone: '' })));

  return (
    <>
      <Header title={i18n.t(`${i18nScope}.title`)} description={i18n.t(`${i18nScope}.description`)} />
      <PhoneForm
        code={code}
        initialValue={phone}
        invalidMessage={i18n.t(`${i18nScope}.phoneInvalid`)}
        analyticsEventGroup={'credentials recovery screen'}
        analyticsEventName={'click send password'}
        buttonLabel={i18n.t(`${i18nScope}.next`)}
        sectionName={SECTION_NAME}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default AuthorizationRestorePasswordPhonePage;
